/**
 * Share one detect promise per story+category so closing the Character
 * picker and reopening it does not start a second identical scan (#1010).
 * The HTTP call is not aborted on unmount — once sent, cancelling it
 * would only orphan paid work and re-fire on the next open.
 */

const inflight = new Map();

export function sharedDetectInflight(key, start) {
  const existing = inflight.get(key);
  if (existing) return existing;
  let started;
  try {
    started = Promise.resolve(start());
  } catch (err) {
    started = Promise.reject(err);
  }
  const promise = started.finally(() => {
    if (inflight.get(key) === promise) inflight.delete(key);
  });
  inflight.set(key, promise);
  return promise;
}

export function resetDetectInflight() {
  inflight.clear();
}

export function detectInflightKey(storyId, category) {
  return `detect:${category}:${storyId}`;
}
